'use client';

import {
  useIsMobile,
} from '@/hooks/use-mobile';
import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
} from 'react';

type SidebarContextType = {
	isExpanded: boolean;
	toggleSidebar: () => void;
	setExpanded: (expanded: boolean) => void;
};

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

type SidebarProviderProps = {
	children: ReactNode;
};

export function SidebarProvider({ children }: SidebarProviderProps) {
  const isMobile = useIsMobile();
  const [isExpanded, setIsExpanded] = useState(!isMobile);

  const toggleSidebar = () => {
    setIsExpanded(prev => !prev);
  };

  const setExpanded = (expanded: boolean) => {
    setIsExpanded(expanded);
  };

  return (
    <SidebarContext.Provider value={{ isExpanded, toggleSidebar, setExpanded }}>
      {children}
    </SidebarContext.Provider>
  );
}

export default function useSidebar() {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
}
